import axios from 'axios';
import { tpoGenUrls } from 'config/urls';
import { queryClient } from 'services/reactQueryService';
import { tpoGenKeys } from '../../utils/tpoGenQueryKeys';

const fetchPlanListApi = async (planningGroupId: string, showMyPlans: boolean, filters: Record<string, any>, sortBy: string, sortOrder: string) => {
    const currentUser = localStorage.getItem('email');
    const response = await axios(tpoGenUrls.getPlanList, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
        data: {
            planning_group_id: planningGroupId,
            sort_by: sortBy,
            sorting_order: sortOrder,
            limit: 30,
            offset: 0,
            search_keyword: '',
            user_id: currentUser,
            my_plans_only: showMyPlans,
            filters: filters,
        },
    });
    return response.data;
};

const fetchPlanList = async (planningGroupId: string, showMyPlans: boolean, filters: Record<string, any>, sortBy: string, sortOrder: string) => {
    const data = await queryClient.fetchQuery({
        queryKey: tpoGenKeys.planList(planningGroupId, showMyPlans, filters, sortBy, sortOrder),
        queryFn: () => fetchPlanListApi(planningGroupId, showMyPlans, filters, sortBy, sortOrder),
    });
    return data;
};

export default fetchPlanList;
